import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { FirmInstruction } from "../../../../../../../Wrap/Models/Models/Company/FirmInstruction";
import { SectionHeader } from "../../../../../../Dashboard/Components/Clients/NewBusinessWizard/Components/SharedComponents";

interface IValidateProps extends React.Props<Validate> {
    isReview?: boolean;
    data: FirmInstruction;
}

interface IValidateState {}

export class Validate extends FormComponent<IValidateProps, IValidateState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render() {
        const { data } = this.props;
        return (
            <>
                <h2>Validation & execute</h2>
                {SectionHeader("Validation data")}
                <p>Check all required data has been entered.</p>
                <table className="table-data table-fluid mt-15 mb-15">
                    <tbody>
                        <tr className="TableDataRow">
                            <th className="TableHead">Page</th>
                            <th className="TableHead">Field</th>
                            <th className="TableHead">Reason</th>
                        </tr>
                        <tr className="TableDataRow">
                            <td className="TableData">
                                <b></b>
                            </td>
                            <td className="TableData"></td>
                            <td className="TableData" style={{ whiteSpace: "normal", textAlign: "center" }}>
                                All data entered has been successfully validated.
                            </td>
                        </tr>
                    </tbody>
                </table>
                <hr />
                {/* {SectionHeader("Wizard Notes")}
                <button className="btn btn-secondary" onClick={() => this.addNotes()}>
                    Edit Notes
                </button>
                <hr /> */}
                {SectionHeader("Implement")}
                <p>
                    {this.props.isReview
                        ? "This wizard has already been submitted for completion"
                        : "To confirm that you wish to proceed to the final step, click here."}
                </p>
            </>
        );
    }
}
